import { UpdateDataDto } from "@common/dto/data/update-dto";
import { clientTransformed } from "@common/utils/rest";

const URL_PREFIX = 'api/data';

const getUrl = (path: string) => {
  return `${URL_PREFIX}/${path}`;
};

export const updateEntity = async (data: UpdateDataDto) => {
  return clientTransformed({
    path: getUrl('save'),
    method: 'POST',
		entity: data,
  });
};